import React, { ReactNode } from 'react';
import { styled } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const Root = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

type CircularProgressBarProps = {
  children: ReactNode;
};

const CircularProgressBar = (props: CircularProgressBarProps) => {
  const { children } = props;

  return (
    <Root>
      <CircularProgress />
      <br />
      {children || <p>Loading...</p>}
    </Root>
  );
};

export default CircularProgressBar;
